// extracted by mini-css-extract-plugin
module.exports = {"container":"Badge_container__iD3Vj","default":"Badge_default__d_dsw","neutral":"Badge_neutral__Q3elE","success":"Badge_success__vAn6G"};